import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useRef } from "react";
import dayjs from "dayjs";
import {
  addBtcDk,
  editBtcDk,
  selectAllBtcDk,
  selectBtcConfig,
  selectBtcDsTv,
  setBtcConfig,
  setBtcDsTv,
} from "../../features/btc/btcSlice";
import {
  selectBtcTv,
  selectGrp,
  selectUsername,
} from "../../features/auth/authSlice";
import {
  createBtcDk,
  getBtcQuy,
  getAllBtcTv,
  updateBtcDk,
} from "../../services/btc/btcApi";
import AddIcon from "@mui/icons-material/Add";
import { CalcTotal, ngayALToDL } from "./BtcUser";

import { getLunarDate } from "../../utils/amlich-hnd";
import { MyBtcLayout, theme } from "./BtcAdmin.js";
import { LularDayPicker } from "./ngayAl.js";
import { getLunarMonthStartEnd } from "./ngayAl.js";
import { EditMenu } from "./Btc.js";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";


import UploadFileIcon from "@mui/icons-material/UploadFile";

const EditForm = ({
  dk,
  onOk,
  onClose = () => {},
  title,
  init = false,
  buttonTitle = "Lưu",
  dsQuy,
}) => {
  const open = init;
  const [editingObj, seteditedObj] = useState(dk);
  // const config = useAppSelector(selectBtcConfig);
  // const dsQuy = config.dsQuy.filter(quy=>!quy.khoa && !quy.private);
  const handleClose = () => {
    onClose();
  };

  function handleChange(key, value) {
    console.log(key, value);
    seteditedObj({ ...editingObj, [key]: value });
  }
  console.log(editingObj);
  var isError =
    isNaN(editingObj.soLuong) ||
    editingObj.soLuong === "" ||
    !dsQuy.find((quy) => quy.msQuy === editingObj.msQuy);
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <Stack direction={"column"}>
            <InputLabel id="quy-label">Quỹ</InputLabel>
            <TextField
              select
              value={editingObj.msQuy}
              onChange={(e) => handleChange("msQuy", e.target.value)}
            >
              {dsQuy.map((quy, i) => (
                <MenuItem
                  key={i}
                  value={quy.msQuy}
                  sx={
                    quy.deleted
                      ? { backgroundColor: theme.palette.error.light }
                      : quy.khoa
                        ? { backgroundColor: theme.palette.secondary.light }
                        : quy.private
                          ? { backgroundColor: theme.palette.warning.light }
                          : {}
                  }
                >
                  {quy.tenQuy}
                </MenuItem>
              ))}
            </TextField>
            <InputLabel id="soluong-label">Số lượng</InputLabel>
            <TextField
              type="number"
              onChange={(e) =>
                handleChange(
                  "soLuong",
                  e.target.value ? parseInt(e.target.value) : 0,
                )
              }
              value={editingObj.soLuong === 0 ? "" : editingObj.soLuong}
            ></TextField>
            <InputLabel id="donvi-label">Đơn vị</InputLabel>
            <Select
              onChange={(e) => handleChange("donVi", e.target.value)}
              value={editingObj.donVi}
            >
              <MenuItem value={"d"}>{"Đồng"}</MenuItem>
              <MenuItem value={"y"}>{"Yên"}</MenuItem>
            </Select>
          </Stack>
        </DialogContent>
        {true && (
          <DialogActions>
            <Button
              disabled={isError}
              onClick={() => {
                handleClose();
                onOk(editingObj);
              }}
              autoFocus
            >
              {buttonTitle}
            </Button>
            <Button onClick={handleClose}>{"Hủy"}</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

const init_viewAll = true;
function changeView(isViewAll, oldDsQuy, avaiableDsQuy) {
  var newDsQuy;
  if (isViewAll) {
    newDsQuy = [...oldDsQuy];
    avaiableDsQuy.forEach((item) => {
      if (!oldDsQuy.find((registerd) => registerd.msQuy === item.msQuy)) {
        newDsQuy.push({
          msQuy: item.msQuy,
          soLuong: 0,
          donVi: "y",
        });
      }
    });
  } else {
    newDsQuy = oldDsQuy.filter((item) => item.soLuong !== 0);
  }

  newDsQuy.sort((a, b) => (a.msQuy > b.msQuy ? 1 : a.msQuy < b.msQuy ? -1 : 0));
  return newDsQuy;
}
function diffBtcDk(orgBtcDk, newTbcDk) {
  var changes = {};
  var newDsQuy = newTbcDk.dsQuy.filter((item) => item.soLuong !== 0);
  if (!eqDsQuy(newDsQuy, orgBtcDk.dsQuy)) {
    changes.dsQuy = newDsQuy;
  }
  ["ngay", "gio", "bill", "note", "email", "flag"].forEach((key) => {
    if (newTbcDk[key] !== orgBtcDk[key]) {
      changes[key] = newTbcDk[key];
    }
  });
  return changes;
}
function eqDsQuy(dsQuyA, dsQuyB) {
  return JSON.stringify(dsQuyA) === JSON.stringify(dsQuyB);
}
/**
 *
 * @param {Date} today
 * @returns yyyy-MM-dd
 */
export function curLunarDay(today = new Date()) {
  var lunar = getLunarDate(
    today.getDate(),
    today.getMonth() + 1,
    today.getFullYear(),
  );
  var ret = `${lunar.year}-${lunar.month
    .toString()
    .padStart(2, "0")}-${lunar.day.toString().padStart(2, "0")}`;
  return ret;
}
const MODE_USER = 1;
const MODE_ADMIN = 2;
const BtcUserDk = ({ navigate, params = {} }) => {
  // console.log("BtcUserDk", "params", params);
  const { id = null, btcUserEmail, ngayAL, showDate = true } = params;

  // + sw modes user/admin
  const mode = btcUserEmail ? MODE_USER : MODE_ADMIN; // 1:crete/edit by user, 2: by admin
  const dispatch = useAppDispatch();

  // GET STORE DATA
  const user = useAppSelector(selectUsername);
  const btcDsDk = useAppSelector(selectAllBtcDk);
  const btcDsTv = useAppSelector(selectBtcDsTv);
  const config = useAppSelector(selectBtcConfig);
  const btcTv = useAppSelector(selectBtcTv);
  const grp = useAppSelector(selectGrp);

  // STATE
  const [s_editingDk, setEditingDk] = useState(null);
  const [s_creating, setCreateState] = useState(false);
  const [s_viewAll, setViewAll] = useState(init_viewAll);
  const inputFile = useRef();

  // + init original dk
  const [orgBtcDk] = useState(() => {
    function initDk() {
      var t_dk;
      if (!Array.isArray(btcDsDk)) {
        // navigate(-1);
        return;
      }
      if (id) {
        // edit existing
        t_dk = btcDsDk.find((obj) => obj.id === id);
      } else {
        var ngay = ngayAL ? ngayALToDL(ngayAL) : dayjs().format("YYYY-MM-DD");
        var gio = dayjs().format("HH:mm:ss");
        // create new
        t_dk = {
          email: btcUserEmail,
          ngay: ngay,
          gio: gio,
          flag: 0, // used by user
          dsQuy: [],
          bill: "",
          note: "",
        };

        // admin mode
        if (mode === MODE_ADMIN) {
          t_dk.email = user;
        }
      }

      return t_dk;
    }
    var t_dk = initDk();

    if (!t_dk) {
      console.error("invalid id:", id);

      // if (window.history.length > 1) {
      //   navigate(-1);
      // } else {
      //   navigate("/", { replace: true }); // fallback route
      // }

      return;
    }

    return t_dk;
  });
  const [curDk, setCurDk] = useState(orgBtcDk);
  const [error, setError] = useState(null);

  // FETCH DATA
  var zBeginOfMonth = "default";
  if (curDk) {
    var [startOfM] = getLunarMonthStartEnd(dayjs(curDk.ngay));
    zBeginOfMonth = startOfM.format("YYYY-MM-DD");
  }

  const useSolar = true; // for test
  if (useSolar) {
    zBeginOfMonth = "default";
  }

  useEffect(() => {
    async function loadDsTv() {
      // case: admin add new
      const { error, result: dsTv } = await getAllBtcTv(grp);
      console.log("getAllBtcTv: ", dsTv);
      if (dsTv) {
        dispatch(setBtcDsTv({ btcDsTv: dsTv }));
        return dsTv;
      } else {
        console.error(error);
      }
    }

    async function load() {
      if (config.ngay !== zBeginOfMonth) {
        var t_config = await loadBtcConfig(zBeginOfMonth, grp);
        console.log("loadBtcConfig", t_config);

        dispatch(setBtcConfig(t_config));
      }

      if (!btcDsTv && mode === MODE_ADMIN) {
        await loadDsTv();
      }
    }

    if (zBeginOfMonth) {
      load();
    }
  }, [zBeginOfMonth, config.ngay, dispatch, btcDsTv, mode, grp]);
  // console.log(btcDsTv, mode);
  // console.log(config, curDk);
  if (
    (mode === MODE_ADMIN && !btcDsTv) ||
    !config ||
    config.ngay !== zBeginOfMonth
  ) {
    return <>Loading...</>;
  }

  // RENDER

  // initDsQuy
  // + thanh phan
  var thanhPhan;
  if (mode === MODE_USER) {
    thanhPhan = btcTv.tp;
  } else {
    var t_dsTv = btcDsTv;
    var t_tv = t_dsTv.find((tv_i) => tv_i.email === curDk.email);
    thanhPhan = t_tv?.tp;
  }

  // + calc all avaiable quy
  const dsQuy_read =
    mode === MODE_ADMIN
      ? config.dsQuy
      : config.dsQuy.filter(
          (quy) => !quy.private && quy.tp.includes(thanhPhan),
        );
  const dsQuy_edit =
    mode === MODE_ADMIN ? dsQuy_read : dsQuy_read.filter((quy) => !quy.khoa);
  // + sort & filter
  var dsQuy = changeView(s_viewAll, curDk.dsQuy, dsQuy_read);

  const changes = diffBtcDk(orgBtcDk, curDk);
  function handleViewAllChange(checked) {
    setViewAll(checked);
  }

  // EVENT HANDLE
  function pathCurDk(changes) {
    setCurDk({ ...curDk, ...changes });
  }
  var { bill, note } = curDk;
  var setBill = (bill) => pathCurDk({ bill });
  var setNote = (note) => pathCurDk({ note });

  // handle mode changes
  function handleModeChg(checked) {
    pathCurDk({ flag: checked ? 1 : 0 });
  }

  function handleTvChange(selectedTv) {
    pathCurDk({
      email: selectedTv.email,
    });
  }

  function onAdd(createdDk) {
    if (createdDk.soLuong !== 0) {
      var newDsQuy = dsQuy.concat(createdDk);
      newDsQuy.sort((a, b) =>
        a.msQuy > b.msQuy ? 1 : a.msQuy < b.msQuy ? -1 : 0,
      );
      setCurDk({ ...curDk, dsQuy: newDsQuy });
    }
    setCreateState(false);
  }
  function onSave(edited) {
    console.log("save dk", edited);
    var idx = dsQuy.indexOf(s_editingDk);
    setCurDk({ ...curDk, dsQuy: dsQuy.toSpliced(idx, 1, edited) });
    setEditingDk(null);
  }
  function onFixed(edited) {
    console.log("fixed dk", edited);
    var idx = dsQuy.indexOf(error);
    setCurDk({ ...curDk, dsQuy: dsQuy.toSpliced(idx, 1, edited) });
    setError();
  }
  function onCancel() {
    setEditingDk(null);
  }
  function handleUploadUnused() {
    inputFile.current.click();
  }
  function handleDelete(index) {
    setCurDk({ ...curDk, dsQuy: dsQuy.toSpliced(index, 1) });
  }
  function handleEdit(index) {
    setEditingDk(dsQuy[index]);
  }
  function handleAdd() {
    setCreateState(true);
  }
  async function handleSave() {
    try {
      var newDsQuy = s_viewAll ? changeView(false, dsQuy, null) : dsQuy;
      if (orgBtcDk.id) {
        // update
        var id = orgBtcDk.id;

        if (Object.keys(changes).length !== 0) {
          // clone changes
          var { error, result } = await updateBtcDk(id, {...changes}, grp);
          if (error) {
            console.error(error);
            return;
          }
          dispatch(editBtcDk({ id, changes }));
        }
        navigate(-1);
      } else {
        // create
        var newBtcDk = {
          ...curDk,
          dsQuy: newDsQuy,
        };
        ({ error, result } = await createBtcDk(newBtcDk, grp));
        if (error) {
          console.error(error);
          return;
        }
        dispatch(addBtcDk({ btcDk: result }));
        navigate(-1);
      }
    } catch (ex) {
      console.error(ex.message);
    }
  }
  const screenOrientation = 0; // 0:landscape
  function handleChange(idx, key, value) {
    var edited = { ...dsQuy[idx] };
    edited[key] = value;
    setCurDk({ ...curDk, dsQuy: dsQuy.toSpliced(idx, 1, edited) });
  }
  const hdr = <></>;
  const isCreate = !orgBtcDk.id;
  function emailCmb() {
    if (mode === MODE_USER) {
      return (
        <>
          <Select value={curDk.email}>
            <MenuItem value={curDk.email}>
              {curDk.email.replace("@gmail.com", "")}
            </MenuItem>
          </Select>
          <Typography>{`Thành phần: ${thanhPhan || "Chưa đặt"}`}</Typography>
        </>
      );
    }
    if (!btcDsTv) {
      return <></>;
    }
    return (
      <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }} alignItems="center">
        <Select
          value={curDk.email}
          onChange={(e) => {
            var selEmail = e.target.value;
            var selTv = btcDsTv.find((obj) => obj.email === selEmail);
            handleTvChange(selTv);
          }}
        >
          {btcDsTv.map((tv_i, i) => (
            <MenuItem key={i} value={tv_i.email}>
              {tv_i.email.replace("@gmail.com", "")}
            </MenuItem>
          ))}
        </Select>
        <Typography>{` - ${thanhPhan || "Chưa đặt"}`}</Typography>
      </Stack>
    );
  }
  // title
  const title = (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {mode === MODE_ADMIN ? (
        emailCmb()
      ) : (
        <Typography>
          {curDk.email.replace("@gmail.com", "")} - {thanhPhan}
        </Typography>
      )}
    </div>
  );
  // filter: admin|view all
  const filter = filterSelect(
    mode,
    btcTv.role,
    curDk.flag,
    handleModeChg,
    s_viewAll,
    handleViewAllChange,
  );
  // footer
  const footer = (
    <div>
      {error ? (
        <Button color={error ? "error" : undefined}>
          {isCreate ? "Thêm mới" : "Lưu"}
        </Button>
      ) : (
        <Button
          onClick={handleSave}
          disabled={Object.keys(changes).length === 0}
        >
          {isCreate ? "Thêm mới" : "Lưu"}
        </Button>
      )}
      <Button onClick={() => navigate(-1)}>{"Hủy"}</Button>
    </div>
  );
  // const ngayDL = dayjs(s_ngay);
  // console.log("s_ngay", s_ngay)

  function validate(dsQuy) {
    var found = dsQuy.find((quy) => isNaN(quy.soLuong));
    if (found) {
      setError(found);
    }
    return found;
  }
  error || validate(dsQuy);

  return (
    <MyBtcLayout title={title} footer={footer}>
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction={"column"}
        sx={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }
        }
      >
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction={"column"}
          sx={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            flexWrap={"wrap"}
            spacing={{ xs: 1, sm: 2 }}
          >
            {showDate && (
              <LularDayPicker
                ngayDL={curDk.ngay}
                setNgayDL={(ngay) => pathCurDk({ ngay })}
                gio={curDk.gio}
                setGio={(gio) => pathCurDk({ gio })}
              ></LularDayPicker>
            )}
            <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }}>
              {showDate && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    // sx={{ mt: 1 }}
                    // label="Dương lịch"
                    value={dayjs(
                      `${curDk.ngay} ${curDk.gio}`,
                      "YYYY-MM-DD HH:mm:ss",
                    )}
                    format="YYYY.MM.DD HH:mm:ss"
                    ampm={false}
                    onAccept={(newValue) =>
                      pathCurDk({
                        ngay: newValue.format("YYYY-MM-DD"),
                        gio: newValue.format("HH:mm:ss"),
                      })
                    }
                    slotProps={{
                      textField: {
                        sx: {
                          width: 220, // 👈 thu hẹp chiều rộng
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              )}

              {filter}
            </Stack>
          </Stack>

          {dsQuy.map((dk, dkIdx) => {
            var quyObj = dsQuy_read.find((item) => item.msQuy === dk.msQuy) || {
              msQuy: dk.msQuy,
              deleted: true,
            };
            var msQuyStyle = quyObj.deleted
              ? { backgroundColor: theme.palette.error.light }
              : quyObj.khoa
                ? { backgroundColor: theme.palette.secondary.light }
                : quyObj.private
                  ? { backgroundColor: theme.palette.warning.light }
                  : {};
            Object.assign(msQuyStyle, { width: "100px" });
            return (
              <Stack
                key={dkIdx}
                direction={"row"}
                alignItems={"center"}
                backgroundColor={dkIdx % 2 ? "#fff" : "#e8fafa"}
              >
                {mode === MODE_ADMIN
                  ? editableDk(
                      hdr,
                      dkIdx,
                      msQuyStyle,
                      dk,
                      (dkIdx, field, value) => {
                        if (field === "soLuong" && isNaN(value)) {
                          setError(dk);
                        } else {
                          handleChange(dkIdx, field, value);
                        }
                      },
                      handleEdit,
                      quyObj,
                      dsQuy_edit,
                    )
                  : quyObj.deleted || !quyObj.khoa
                    ? editableDk(
                        hdr,
                        dkIdx,
                        msQuyStyle,
                        dk,
                        (dkIdx, field, value) => {
                          if (field === "soLuong" && isNaN(value)) {
                            setError(dk);
                          } else {
                            handleChange(dkIdx, field, value);
                          }
                        },
                        handleEdit,
                        quyObj,
                        dsQuy_edit,
                      )
                    : readonlyDk(dk, quyObj, handleEdit, dkIdx, handleDelete)}
              </Stack>
            );
          })}
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "aliceblue",
            }}
          >
            <IconButton onClick={handleAdd} color="primary" size="large">
              <AddIcon></AddIcon>
            </IconButton>
          </div>
        </Stack>
        <Stack
          direction={"column"}
          spacing={{ xs: 1, sm: 2 }}
          sx={{ height: "200px" }}
        >
          <Typography variant="h5">{"Tổng: " + CalcTotal(dsQuy)}</Typography>

          <ImageUploader value={bill} setBill={setBill} />

          <TextField
            id="outlined-multiline-static"
            label="Ghi chú"
            multiline
            value={note}
            variant="outlined"
            minRows={3}
            fullWidth
            onChange={(e) => setNote(e.target.value)}
          />
        </Stack>
      </Stack>
      {s_editingDk && (
        <EditForm
          dk={s_editingDk}
          onOk={onSave}
          onClose={onCancel}
          init={true}
          title={"Sửa lại đăng ký"}
          dsQuy={dsQuy_edit}
        />
      )}
      {s_creating && (
        <EditForm
          dk={{
            msQuy: "",
            soLuong: 0,
            donVi: "y",
          }}
          onOk={onAdd}
          onClose={() => setCreateState(false)}
          init={true}
          title={"Thêm mới đăng ký"}
          buttonTitle="Thêm mới"
          dsQuy={dsQuy_edit}
        />
      )}
      {error && (
        <EditForm
          dk={error}
          onOk={(edited) => {
            onFixed(edited);
          }}
          onClose={onCancel}
          init={true}
          title={"Sửa lại đăng ký bị lỗi"}
          buttonTitle="Sửa"
          dsQuy={dsQuy_edit}
        />
      )}
    </MyBtcLayout>
  );
};

export default BtcUserDk;

function processImage(file, setBill) {
  if (!file) return;

  const reader = new FileReader();

  reader.onloadend = function (e) {
    const image = new Image();
    image.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const max_size = 1024;
      let { width, height } = image;

      if (width > height) {
        if (width > max_size) {
          height *= max_size / width;
          width = max_size;
        }
      } else {
        if (height > max_size) {
          width *= max_size / height;
          height = max_size;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(image, 0, 0, width, height);

      const dataUrl = canvas.toDataURL("image/jpeg", 0.8);
      setBill(dataUrl);
    };
    image.src = e.target.result;
  };

  reader.readAsDataURL(file);
}

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

function ImageUploader({ value, setBill }) {
  // const inputRef = useRef(null);
  const pasteZoneRef = useRef(null);

  /* ---------- auto focus ---------- */
  useEffect(() => {
    pasteZoneRef.current?.focus();
  }, []);

  const handleFile = async (file) => {
    if (!file) return;

    if (file.type.startsWith("image/")) {
      // xử lý image
      processImage(file, setBill);
      return;
    }

    if (file.type === "application/pdf") {
      const base64 = await fileToBase64(file);
      setBill(base64);
      return;
    }

    // fallback
    alert("Chỉ hỗ trợ ảnh hoặc PDF");
  };

  /* ---------- events ---------- */
  const handleChange = (e) => {
    handleFile(e.target.files?.[0]);
    e.target.value = "";
  };

  const handlePaste = (e) => {
    const items = e.clipboardData?.items;
    if (!items) return;

    for (const item of items) {
      if (item.type.startsWith("image/") || item.type === "application/pdf") {
        handleFile(item.getAsFile());
        e.preventDefault();
        break;
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files?.[0]);
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setBill(null);
    requestAnimationFrame(() => pasteZoneRef.current?.focus());
  };

  const isPdf = value?.startsWith("data:application/pdf");
  const isImage = value?.startsWith("data:image/");

  return (
    <>
      {/* Paste / Upload / Drop Zone */}
      <Box
        ref={pasteZoneRef}
        tabIndex={0}
        // role="button"
        onPaste={handlePaste}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        sx={{
          position: "relative",
          border: "2px dashed",
          borderColor: "grey.400",
          borderRadius: 2,
          p: 2,
          textAlign: "center",
          // cursor: "pointer",
          outline: "none",
          "&:focus": {
            borderColor: "primary.main",
            bgcolor: "action.hover",
          },
        }}
      >
        {/* PREVIEW */}
        {value ? (
          <>
            {/* IMAGE PREVIEW */}
            {isImage && (
              <img
                src={value}
                alt="Bill preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: 240,
                  borderRadius: 8,
                }}
              />
            )}

            {/* PDF PREVIEW */}
            {isPdf && (
              <iframe
                src={value}
                title="PDF preview"
                style={{
                  width: "100%",
                  height: 300,
                  border: "none",
                  borderRadius: 8,
                }}
              />
            )}

            {/* REMOVE BUTTON */}
            <IconButton
              size="small"
              onClick={removeImage}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                bgcolor: "rgba(0,0,0,0.6)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        ) : (
          <Stack direction={"column"} spacing={1} alignItems="center">
            <Typography variant="body2">Click / Drag / Ctrl + V</Typography>
            <Typography variant="caption" color="text.secondary">
              Hỗ trợ: Ảnh hoặc PDF
            </Typography>

            <Button
              sx={{ mt: 1 }}
              size="small"
              variant="contained"
              component="label"
              startIcon={<UploadFileIcon />}
            >
              {/* Hidden file input */}
              <input
                type="file"
                accept="image/*,application/pdf"
                hidden
                onChange={handleChange}
              />
              Gửi bill
            </Button>
          </Stack>
        )}
      </Box>
    </>
  );
}

function filterSelect(
  mode,
  role,
  flag,
  handleModeChg,
  viewAll,
  handleViewAllChange,
) {
  return (
    <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }} justifyContent="right">
      {mode === 1 ? (
        <div></div>
      ) : (
        role === "admin" && (
          <div>
            <Select
              style={{
                width: "100px",
                backgroundColor: theme.palette.warning.light,
              }}
              onChange={(e) => handleModeChg(e.target.value)}
              value={flag === 1}
            >
              <MenuItem value={false}>{"User"}</MenuItem>
              <MenuItem value={true}>{"Admin"}</MenuItem>
            </Select>
          </div>
        )
      )}
      <div>
        <Select
          style={{ width: "100px" }}
          onChange={(e) => handleViewAllChange(e.target.value)}
          value={viewAll}
        >
          <MenuItem value={false}>{"Rút gọn"}</MenuItem>
          <MenuItem value={true}>{"Tất cả"}</MenuItem>
        </Select>
      </div>
    </Stack>
  );
}
function readonlyDk(dk, quyObj, handleEdit, dkIdx, handleDelete) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div style={{ margin: "0.5rem" }}>
        <Typography>{`${dk.msQuy} ${quyObj ? "(" + quyObj.tenQuy + ")" : ""} ${
          dk.soLuong
        } ${dk.donVi === "y" ? "Yên" : "Đồng"}`}</Typography>
      </div>
      {/* <ButtonGroup variant="contained">
        <Button size="small" onClick={() => handleEdit(dkIdx)}>
          {"Sửa"}
        </Button>
        <ConfirmButton
          onOk={() => handleDelete(dkIdx)}
          title={"Xác nhận xóa"}
          message={"Bạn có muốn xóa không? (Ấn [Có] để xóa quỹ)"}
        >
          <Button size="small">{"Xóa"}</Button>
        </ConfirmButton>
      </ButtonGroup> */}
    </div>
  );
}

function editableDk(
  hdr,
  dkIdx,
  msQuyStyle,
  dk,
  handleChange,
  handleEdit,
  quyObj,
  avaiableDsQuy,
) {
  return (
    <>
      <Stack direction={"row"} spacing={{ xs: 1, sm: 2 }}>
        <FormControl sx={{ minWidth: 100 }}>
          <InputLabel id="demo-select-small-label">{"Quỹ"}</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            style={msQuyStyle}
            value={dk.msQuy}
            label={"Quỹ"}
            onChange={(e) => handleChange(dkIdx, "msQuy", e.target.value)}
          >
            {!quyObj
              ? [<MenuItem key={dk.msQuy}>{dk.msQuy}</MenuItem>]
              : avaiableDsQuy.map((quyCfg) => (
                  <MenuItem key={quyCfg.msQuy} value={quyCfg.msQuy}>
                    {`${quyCfg.msQuy} ${quyCfg.tenQuy}`}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>
        <Box width={{ xs: "auto", sm: "auto" }}>
          <TextField
            autoComplete="off"
            inputProps={{
              step: 100,
            }}
            type="number"
            error={isNaN(dk.soLuong)}
            id="outlined-error-helper-text"
            label="Số lượng"
            helperText={isNaN(dk.soLuong) ? "Nhập sai!" : ""}
            onChange={(e) => {
              handleChange(
                dkIdx,
                "soLuong",
                e.target.value ? parseInt(e.target.value) : 0,
              );
            }}
            value={dk.soLuong === 0 ? "" : dk.soLuong}
          />
        </Box>

        <FormControl sx={{ minWidth: 90 }}>
          <InputLabel id="demo-select-small-label">{"Đơn vị"}</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            label="Đơn vị"
            onChange={(e) => handleChange(dkIdx, "donVi", e.target.value)}
            value={dk.donVi}
          >
            <MenuItem value={"d"}>{"Đồng"}</MenuItem>
            <MenuItem value={"y"}>{"Yên"}</MenuItem>
          </Select>
        </FormControl>
        {/* <Button onClick={() => handleChange(dkIdx, "soLuong", 0)}>
        {"Xóa"}
      </Button> */}
      </Stack>
      <EditDkMenu
        handleChange={handleChange}
        handleEdit={handleEdit}
        dkIdx={dkIdx}
      />
    </>
  );
}
function EditDkMenu({ handleChange, handleEdit, dkIdx }) {
  return (
    <EditMenu
      options={[
        { cb: () => handleEdit(dkIdx), label: "Sửa" },
        { cb: () => handleChange(dkIdx, "soLuong", 0), label: "Xóa" },
      ]}
    >
      <MoreVertIcon />
    </EditMenu>
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton
        variant="outlined"
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            handleEdit(dkIdx);
          }}
        >
          {"Sửa"}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleChange(dkIdx, "soLuong", 0);
          }}
        >
          {"Xóa"}
        </MenuItem>
      </Menu>
    </div>
  );
}

/**
 *
 * @param {string} zBeginOfMonth YYYY-MM-DD
 * @returns
 */
export async function loadBtcConfig(zBeginOfMonth, grp) {
  var { result, error } = await getBtcQuy({ ngay: zBeginOfMonth, grp });
  console.log("getBtcQuy ngay:", zBeginOfMonth, "result:", result);

  if (error === "not found") {
    // use default config
    ({ result, error } = await getBtcQuy({ ngay: "default", grp }));
    console.log("getBtcQuy ngay:", "default", "result:", result);
  }

  if (result) {
    var t_config = { ...result, ngay: zBeginOfMonth };
    return t_config;
  }

  console.error(error);
  return { dsQuy: [], ngay: zBeginOfMonth };
}
